const config = {
  api: process.env.API_URL || 'http://flexpay-dev-paloteb394024.codeanyapp.com',
  port: process.env.PORT || 9001,
  redis: process.env.REDIS_URL || 'redis://localhost:6379',
  awsRegion: process.env.AWS_REGION || 'us-east-1',
  awsBucketName: process.env.AWS_BUCKET_NAME || 'flexpaydev'
};

export default config;



// WEBPACK FOOTER //
// ./source/server/config/index.js